import React from 'react';

const WelcomeFlow = ({ onViewChange, onGuestLogin, onOldhamLogin }) => {
  return (
    <>
      <div className="auth-card-header">
        <h2 className="auth-card-title">Welcome!</h2>
        <p className="auth-card-subtitle">Choose how you&apos;d like to continue:</p>
      </div>

      <div className="auth-card-content">
        <p className="button-helpertext">Existing user?</p>
        <button 
          className="auth-card-button primary"
          onClick={() => onViewChange('login')}
        >
          Log In
        </button>

        <p className="button-helpertext">New user?</p>
        <button 
          className="auth-card-button secondary"
          onClick={() => onViewChange('register')}
        >
          Sign Up
        </button>

        <p className="button-helpertext">Oldham Lab member?</p>
        <button 
          className="auth-card-button secondary"
          onClick={onOldhamLogin}
        >
          Oldham Login
        </button>

        <div className="auth-card-divider">
          <span className="auth-card-divider-text">OR</span>
        </div>

        <button 
          className="auth-card-button tertiary"
          onClick={onGuestLogin}
        >
          Explore as Guest
        </button>
      </div>
    </>
  );
};

export default WelcomeFlow;
